


















































import {Component, Prop, Vue} from 'vue-property-decorator';
import {DncFamily, DncFamilyGroup} from '@/modules/neovehicle/models/dnc';
import {Action, Getter} from 'vuex-class';
import {ActionTypes, GetterTypes} from '@/modules/neovehicle/store/types';
import {DncFamilyGroupFilter} from '@/modules/neovehicle/models/filters';
import {GET_COUNTRY_SELECTED} from '@/store/root';
import {CountryEnum} from '@/models/Enums';

@Component
export default class extends Vue {
  @Prop({required: true})
  public dncFamilies: DncFamily[];

  @Prop({required: true})
  public isOpen: boolean;

  @Getter(GET_COUNTRY_SELECTED)
  public countrySelected: CountryEnum;

  @Getter(GetterTypes.GET_DNC_FAMILY_GROUPS)
  public dncFamilyGroups: DncFamilyGroup[];

  @Action(ActionTypes.FETCH_DNC_FAMILY_GROUPS)
  public fetchDncFamilyGroups: (filter: DncFamilyGroupFilter) => Promise<DncFamilyGroup[]>;

  public isOpenInternal: boolean = false;

  public idDncFamilyGroup: number | undefined = 0;

  public headers = [
    {text: 'Bandeira', value: 'brandname', show: true},
    {text: 'Nome Família', value: 'familyname', show: true},
    {text: 'Segmento', value: 'segmentname', show: true},
  ];

  public async mounted() {
    this.isOpenInternal = this.isOpen;

    await this.fetchDncFamilyGroups({
      country: this.countrySelected,
      idBrand: this.dncFamilies[0].idbrand,
    });

    this.idDncFamilyGroup = this.dncFamilies[0].iddncfamilygroup;
  }

  public get isValid() {
    return this.idDncFamilyGroup !== 0
        && this.dncFamilies.length !== 0;
  }

  public handleCancel() {
    this.$emit('cancel');
  }

  public handleSave() {
    this.$emit('save', this.dncFamilies.map((x) => ({
      idDncFamilyGroup: x.iddncfamilygroup,
      idDncFamilyGroupNew: this.idDncFamilyGroup,
      idFamily: x.idfamily,
    })));
  }
}
